:host {
  display: block;
  max-width: 100%;
}

.error {
  display: none;
}

.wrapper {
  padding: 2px;
  flex-direction: column;

  #title {
    padding: 0 0 calc(var(--spacer) * 2.12) 0;
    color: var(--chart-300-icon-buttons);
    text-transform: uppercase;
  }

  .details-container {
    gz-labeled-content {
      line-height: 12px;
    }
  }

  &.is-loading {
    .details-container {
      display: none;
    }
    .loader {
      display: block;
    }
    .error {
      display: none;
    }
  }

  &.is-error {
    .error {
      display: block;
    }
    .loader {
      display: none;
    }
    .details-container {
      display: none;
    }
  }

  &:not(.is-loading):not(.is-error) {
    .details-container {
      display: block;
    }
    .loader {
      display: none;
    }
    .error {
      display: none;
    }
  }
}
